/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetEvent200Response } from '../models';
// @ts-ignore
import type { MarkEventsAsReceivedDTO } from '../models';
/**
 * EventApi - axios parameter creator
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint which can be used to get a raw event by the eventId parameter. This returns the event metadata, plus the original data in the `original` property.
         * @summary Get event by ID
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getEvent', 'eventId', eventId)
            const localVarPath = `/api/nora/event/event/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for clients to setup an SSE stream for event communication. This endpoint takes the user ID from the bearer token, and only sends relevant events for that user.
         * @summary Listen for events
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForEvents: async (deviceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/event/listen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks an event as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark an event as received
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEventAsReceived: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('markEventAsReceived', 'eventId', eventId)
            const localVarPath = `/api/nora/event/{eventId}/mark-as-received`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks events as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark events as received
         * @param {MarkEventsAsReceivedDTO} markEventsAsReceivedDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEventsAsReceivedBulk: async (markEventsAsReceivedDTO: MarkEventsAsReceivedDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markEventsAsReceivedDTO' is not null or undefined
            assertParamExists('markEventsAsReceivedBulk', 'markEventsAsReceivedDTO', markEventsAsReceivedDTO)
            const localVarPath = `/api/nora/event/mark-as-received`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markEventsAsReceivedDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint which can be used to get a raw event by the eventId parameter. This returns the event metadata, plus the original data in the `original` property.
         * @summary Get event by ID
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvent(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEvent200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvent(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.getEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint for clients to setup an SSE stream for event communication. This endpoint takes the user ID from the bearer token, and only sends relevant events for that user.
         * @summary Listen for events
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listenForEvents(deviceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listenForEvents(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.listenForEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks an event as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark an event as received
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEventAsReceived(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEventAsReceived(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.markEventAsReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks events as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark events as received
         * @param {MarkEventsAsReceivedDTO} markEventsAsReceivedDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markEventsAsReceivedBulk(markEventsAsReceivedDTO: MarkEventsAsReceivedDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markEventsAsReceivedBulk(markEventsAsReceivedDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.markEventsAsReceivedBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventApi - factory interface
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * Endpoint which can be used to get a raw event by the eventId parameter. This returns the event metadata, plus the original data in the `original` property.
         * @summary Get event by ID
         * @param {EventApiGetEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(requestParameters: EventApiGetEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetEvent200Response> {
            return localVarFp.getEvent(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for clients to setup an SSE stream for event communication. This endpoint takes the user ID from the bearer token, and only sends relevant events for that user.
         * @summary Listen for events
         * @param {EventApiListenForEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listenForEvents(requestParameters: EventApiListenForEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.listenForEvents(requestParameters.deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks an event as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark an event as received
         * @param {EventApiMarkEventAsReceivedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEventAsReceived(requestParameters: EventApiMarkEventAsReceivedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markEventAsReceived(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks events as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
         * @summary Mark events as received
         * @param {EventApiMarkEventsAsReceivedBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markEventsAsReceivedBulk(requestParameters: EventApiMarkEventsAsReceivedBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markEventsAsReceivedBulk(requestParameters.markEventsAsReceivedDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getEvent operation in EventApi.
 */
export interface EventApiGetEventRequest {
    readonly eventId: string
}

/**
 * Request parameters for listenForEvents operation in EventApi.
 */
export interface EventApiListenForEventsRequest {
    readonly deviceId?: string
}

/**
 * Request parameters for markEventAsReceived operation in EventApi.
 */
export interface EventApiMarkEventAsReceivedRequest {
    readonly eventId: string
}

/**
 * Request parameters for markEventsAsReceivedBulk operation in EventApi.
 */
export interface EventApiMarkEventsAsReceivedBulkRequest {
    readonly markEventsAsReceivedDTO: MarkEventsAsReceivedDTO
}

/**
 * EventApi - object-oriented interface
 */
export class EventApi extends BaseAPI {
    /**
     * Endpoint which can be used to get a raw event by the eventId parameter. This returns the event metadata, plus the original data in the `original` property.
     * @summary Get event by ID
     * @param {EventApiGetEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEvent(requestParameters: EventApiGetEventRequest, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).getEvent(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for clients to setup an SSE stream for event communication. This endpoint takes the user ID from the bearer token, and only sends relevant events for that user.
     * @summary Listen for events
     * @param {EventApiListenForEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listenForEvents(requestParameters: EventApiListenForEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).listenForEvents(requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks an event as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
     * @summary Mark an event as received
     * @param {EventApiMarkEventAsReceivedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markEventAsReceived(requestParameters: EventApiMarkEventAsReceivedRequest, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).markEventAsReceived(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks events as received, this is NOT related to the chats \"seen\" function, and merely describes whether the event has been received by a device from that user.
     * @summary Mark events as received
     * @param {EventApiMarkEventsAsReceivedBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markEventsAsReceivedBulk(requestParameters: EventApiMarkEventsAsReceivedBulkRequest, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).markEventsAsReceivedBulk(requestParameters.markEventsAsReceivedDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

